module.exports = __webpack_public_path__ + "static/media/logo.1a8f57ca.png";